
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-7",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","class":"w-7","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.534 4.836l4.958 3.138c.011-.188.058-.366.058-.565C15.55 3.316 12.07 0 7.775 0S0 3.316 0 7.409c0 4.092 3.48 7.409 7.775 7.409.082 0 .163-.023.244-.023V6.122c0-1.23 1.444-1.974 2.514-1.286z","fill":"#E3BFF8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.02 6.122c0-1.231 1.431-1.974 2.514-1.286l4.957 3.149.001-.01 4.784 3.027c.966.61.966 1.963 0 2.562l-9.742 6.178c-1.07.676-2.514-.056-2.514-1.287V6.122z","fill":"#A127E8"}})])
          )
        }
      }
    